import type { Enums } from "../types";

/**
 * `taken-over` is amber and nothing else is, because it is the one event a reader is looking for.
 * A handover is where the leg row stops being the truth — it overwrites the holder it replaces —
 * so the row that records one is the row somebody investigating a missing carrier needs to find.
 */
export function getTransportOrderEventColor(event: Enums<"transportOrderEvent">): Enums<"color"> {
	switch (event) {
		case "raised":
			return "gray";
		case "picked-up":
			return "blue";
		case "taken-over":
			return "amber";
		case "delivered":
			return "emerald";
		case "canceled":
			return "slate";
	}
}
